import DeviceErrorComponent from "../FormElements/DeviceSelectionErrorComponent.tsx";
import {useState} from "react";
import {useCustomer} from "../../../../layouts/SelfcareLayout.tsx";
import {FlowData, ProductInstance, SELFCARE_REPORT_FLOW_TYPE} from "../../../../util/types.ts";
import ContactInformationComponent from "../FormElements/ContactInformationComponent.tsx";
import ConnectionTypeComponent from "../FormElements/ConnectionTypeComponent.tsx";
import FormFieldsetComponent from "../FormElements/FormFieldsetComponent.tsx";
import DescriptionTextFieldComponent from "../FormElements/DescriptionTextFieldComponent.tsx";
import OwnHardwareComponent from "../FormElements/OwnHardwareComponent.tsx";
import ErrorFlowButtons from "../FormElements/ErrorFlowButtonsComponent.tsx";
import {DispatchResetErrorReportPageEvent} from "../../../../util/events.ts";
import {submitFormFunction} from "../../../../util/SelfcareErrorReportTypes.ts";
import AttachFilesComponent from "../FormElements/AttachFilesComponent.tsx";
import {anyComponentsWithValidationError, registerComponentsWithValidation} from "../../../../util/helpers.ts";

export default function OtherSpeedFlow({product, submitFunction}: { product: ProductInstance, submitFunction: submitFormFunction }) {
    const {customer} = useCustomer();
    const flowType = SELFCARE_REPORT_FLOW_TYPE.SPEED;
    const [submitting, setSubmitting] = useState<boolean>(false)
    const [submitError, setSubmitError] = useState<string>('');

    const [flowData, setFlowData] = useState<FlowData>({
        flowtype: flowType,
        technology: product.product.att_statistics_technology,
        email: customer.customer_contact.email,
        phone: customer.customer_contact.mobile_no,
        selectedContact: { email: false, phone: false },
        editingContact: {email: false, phone: false},
        devices: [],
        otherDeviceDescription: '',
        descriptionText: '',
        ownHardware: null,
        ownHardwareDescription: '',
        connectionType: '',
        attachedFiles: [] as File[],
    });

    const handleSubmit = async () => {

        if (anyComponentsWithValidationError(flowData)) {
            return;
        }

        setSubmitting(true)
        submitFunction(customer.customer_id, product.product_instance_id, flowData)
            .then((result) => {
                setSubmitError(result)
                setSubmitting(false)
            })
    };

    return (
        <>
            <FormFieldsetComponent
                number={2}
                title={'Uddyb'}
                className={'explain'}
            >
                <ConnectionTypeComponent
                    flowData={flowData}
                    setFlowData={setFlowData}
                    flowtype={flowType}
                    register={registerComponentsWithValidation}
                />

                <DeviceErrorComponent
                    flowData={flowData}
                    setFlowData={setFlowData}
                    register={registerComponentsWithValidation}
                />

                <OwnHardwareComponent
                    flowData={flowData}
                    setFlowData={setFlowData}
                    register={registerComponentsWithValidation}
                />

                <DescriptionTextFieldComponent
                    flowData={flowData}
                    setFlowData={setFlowData}
                    flowtype={flowType}
                    placeholder={'Eks. "Jeg får ca. xx mbit når jeg tester trådløst med min telefon på speedtest.net", "Jeg har netop foretaget en kablet test med min computer, og jeg måler xx mbit"'}
                    register={registerComponentsWithValidation}
                />

                <AttachFilesComponent
                    setFlowData={setFlowData}
                    product={product}
                    flow={SELFCARE_REPORT_FLOW_TYPE.OFFLINE}
                />

            </FormFieldsetComponent>

            <FormFieldsetComponent
                number={3}
                title={'Kontakt'}
                className={'contact'}
            >
                <ContactInformationComponent
                    flowData={flowData}
                    setFlowData={setFlowData}
                    register={registerComponentsWithValidation}
                />
                {submitError.length > 0 &&
                    <div className={`input-container error`}>
                        <p className={'error-message'}>{submitError}</p>
                    </div>
                }
                <ErrorFlowButtons
                    onBack={() => DispatchResetErrorReportPageEvent()}
                    onSubmit={handleSubmit}
                    loading={submitting}
                />
            </FormFieldsetComponent>
        </>
    );
}
